import { reportPermissionsOf } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { StoresReportsIndexPage } from "@/features/stores/components/reports-pages";

export const Route = createFileRoute("/_app/stores/reports/")({
  beforeLoad: () => {
    // Any Stores Report's own code opens the page (user, 2026-10-16).
    const { can } = useAuth.getState();
    if (!reportPermissionsOf("stores").some((c) => can(c)))
      throw redirect({ to: "/" });
  },
  component: StoresReportsIndexPage,
});
